import { WithScope } from '@mews-commander/types';
import { useCommanderSelector } from '@mews-commander/utils';
import { DefaultErrorBoundary, ErrorHandler, OverlayedLoader } from '@mews-commander/ui';
import { ScopeProvider, useFeatureFlag } from '@mews/framework';
import { useAreReservationOrderItemsFetching } from '@mews-commander/core/entities';
import { FeatureFlag } from '@mews-commander/enums';
import { areOrderItemsFetching, hasOrderItemsFetchingFailed } from '../selectors';
import { WithReservationsSameService } from './withReservationsSameService';

interface WithScopeAndChildren extends WithScope {
    children?: React.ReactNode;
}

export const DefaultTabLoader: React.FC<WithScopeAndChildren> = ({ scope, children }) => {
    const isFetchingRedux = useCommanderSelector((s) => areOrderItemsFetching(s, { scope }));
    const isFetchingQuery = useAreReservationOrderItemsFetching(scope);
    const isReservationModuleReactQueryEnabled = useFeatureFlag(FeatureFlag.reservationModuleReactQueryEnabled);
    const isFetching = isReservationModuleReactQueryEnabled ? isFetchingQuery : isFetchingRedux;
    const hasFailed = useCommanderSelector((s) => hasOrderItemsFetchingFailed(s, { scope }));

    if (hasFailed) return <ErrorHandler />;

    return (
        <DefaultErrorBoundary>
            <ScopeProvider value={scope}>
                <WithReservationsSameService scope={scope}>
                    <OverlayedLoader show={isFetching} />
                    {children}
                </WithReservationsSameService>
            </ScopeProvider>
        </DefaultErrorBoundary>
    );
};
